// extracted by mini-css-extract-plugin
export var orderDetails = "_u9-2";
export var orderImage = "_u9-1";
export var orderMeta = "_u9-3";
export var orderSummary = "_u9-0";
export var rightArrow = "_u9-4";